import { InputProps } from "antd";
import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";

import { BorderedInput, BorderedTextArea } from "../../common/Input";
import { PPressContextParams, PpressContext, OnChangeTrigger } from "../context";

interface PPressTextAreaProps {
  name: string;
  className?: string;
  placeholder?: string;
  value?: string;
  disabled?: boolean;
  ignore_min_height?: boolean;
  additional_on_change?: () => void;
}

const StyledInput = styled(BorderedInput)`
  &.inline {
    width: 80px;
  }

  &.small {
    padding: 1px 5px;
  }
`;

const StyledTextArea = styled(BorderedTextArea)`
  min-height: 150px !important;
`;

export const TextArea = (props: PPressTextAreaProps) => {
  const form_state = useContext(PpressContext) as PPressContextParams;

  // having a local state to maintain the user types can be useful to validate the
  // user input before updating the global state.
  const [value, setValue] = useState(props.value ?? "");

  if (!props.ignore_min_height) {
    return (
      <StyledTextArea
        autoSize={true}
        className={"coeff__ppress_textarea " + props.className}
        value={value}
        disabled={props.disabled}
        placeholder={props.placeholder}
        onChange={e => {
          setValue(e.target.value);
          if (props.additional_on_change) {
            props.additional_on_change();
          }
        }}
        onBlur={e => form_state.updatePPressParams({ [props.name]: value })}
        data-test-id={`ppress-textarea-${props.name}`}
        data-1p-ignore
      />
    );
  }

  return (
    <BorderedTextArea
      autoSize={true}
      className={"coeff__ppress_textarea " + props.className}
      value={value}
      disabled={props.disabled}
      placeholder={props.placeholder}
      onChange={e => {
        setValue(e.target.value);
        if (props.additional_on_change) {
          props.additional_on_change();
        }
      }}
      // @ts-ignore
      onKeyUp={e => form_state.updatePPressParams({ [props.name]: value })}
      onBlur={e => form_state.updatePPressParams({ [props.name]: value })}
      data-test-id={`ppress-textarea-${props.name}`}
      data-1p-ignore
      {...props}
    />
  );
};

interface PPressTextBoxProps extends InputProps {
  name: string;
  updateParamsOnKeyUp?: boolean;
  triggersOnChange?: Array<OnChangeTrigger>;
}

export const TextBox = (props: PPressTextBoxProps) => {
  const form_state = useContext(PpressContext) as PPressContextParams;

  const [value, setValue] = useState(props.value ?? "");
  useEffect(() => {
    setValue(props.value ?? "");
  }, [props.value]);
  return (
    <StyledInput
      className={"coeff__ppress_textbox " + props.className}
      value={value}
      title={props.title}
      disabled={props.disabled}
      min={props.min}
      max={props.max}
      type={props.type}
      placeholder={props.placeholder}
      onChange={e => setValue(e.target.value)}
      onKeyUp={e => {
        const propValue = props.type === "number" && !value ? "0" : value;
        if (props.updateParamsOnKeyUp) {
          form_state.updatePPressParams({ [props.name]: propValue });
        }
        if (props.triggersOnChange) {
          form_state.triggersOnChange(props.triggersOnChange);
        }
      }}
      onBlur={e => {
        if (props.onBlur) {
          props.onBlur(e);
        } else {
          let propValue = value;

          if (props.type === "number" && !propValue) {
            propValue = "0";
            setValue(propValue);
          }

          form_state.updatePPressParams({ [props.name]: propValue });
        }
      }}
      data-test-id={`ppress-input-${props.name}`}
      data-1p-ignore
    />
  );
};
